import { action } from 'satcheljs/lib/legacy';
import SubjectPickerViewState from '../store/schema/SubjectPickerViewState';
import { logUsage } from 'owa-analytics';

export type ShowHideSubjectPickerReason =
    | 'SubjectTyped'
    | 'SubjectCleared'
    | 'PopupDismissed'
    | 'PopupClosedByXButton'
    | 'InputFocused'
    | 'ConversationSelected'
    | 'EscPressed';

export default action('showHideSubjectPicker')(function showHideSubjectPicker(
    viewState: SubjectPickerViewState,
    isOpened: boolean,
    reason: ShowHideSubjectPickerReason
) {
    viewState.isPickerOpened = isOpened;

    logUsage(
        'SubjectPicker_ShowHide',
        { isOpened: isOpened, reason: reason },
        {
            // This is temporary to get data in MSIT. Should be removed before starting Prod rollout
            // https://msfast.visualstudio.com/FAST/Office%20People%20HD/_workitems/edit/253222
            isCore: true,
        }
    );
});
